import React from 'react';
import { Medal, Plane, School, Coins, Landmark, Globe, Users, Calculator } from 'lucide-react';
import { IMAGES, BENEFITS } from '../mock';

const iconMap = { Medal, Plane, School, Coins, Landmark, Globe, Users, Calculator };

export default function Benefits() {
  return (
    <section className="gradient-bg-light relative py-20">
      <div className="max-w-6xl mx-auto px-6 text-center">
        <p className="text-[#a020c9] tracking-widest text-sm font-semibold uppercase">— Descubra —</p>
        <h2 className="font-heading font-extrabold text-4xl md:text-5xl text-[#7a1fb0] mt-2 mb-14">
          O QUE VOCÊ PODE GANHAR?
          <div className="h-1 w-24 bg-[#ec2fd2] mx-auto mt-4 rounded"></div>
        </h2>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4 mb-12 max-w-4xl mx-auto">
          {BENEFITS.map((b, i) => {
            const Icon = iconMap[b.icon] || Medal;
            return (
              <div key={i} className={`tag-chip ${b.color === 'magenta' ? 'tag-magenta' : 'tag-purple'}`}>
                <span>{b.label}</span>
                <Icon size={16} />
              </div>
            );
          })}
        </div>

        <div className="flex justify-center">
          <img src={IMAGES.sween2} alt="Sween Feliz" className="max-w-[420px] w-full" />
        </div>
      </div>
    </section>
  );
}
